// import React, { useState, useEffect } from "react";
// import "../Style/AddItemModal.css";
// import "../Style/Common.css";
// import Footer from "../Footer/Footer";
// import { useNavigate } from "react-router-dom";
// import { deleteItem, fetchCategories, getBrands, getItems, getManufacturer } from "../Services/inventoryService";
// import {
//   DataGrid,
//   GridColDef,
//   GridPaginationModel,
//   GridRowModel,
// } from "@mui/x-data-grid";
// import { IUpdateItemRequest } from "../Interfaces/IInventory";
// import Swal from "sweetalert2";
// import { Box, Container } from "@mui/material";
// import { Tooltip } from "@mui/material";
// import IconButton from "@mui/material/IconButton";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import { useSnackbar } from "notistack";
// import { HEADER_NAMES, LBL_Search } from "../Constants/LabelConstants";

// interface ItemAttribute {
//   attribute: string | number;
//   option: string | number;
//   orgId: string;
//   availableOptions:  { id: number; name: string }[];
// }

// export interface Item {
//   id: string;
//   itemId: string;
//   type: string;
//   name: string;
//   sku: string;
//   costPrice: number;
//   sellingPrice: number;
//   upc?: string;
//   ian?: string;
//   hsn: string;
//   reorderPoint: number;
//   desc: string;
//   brandId: string;
//   categoryId: string;
//   manufacturerId: string;
//   itemType: string;
//   taxable: boolean;
//   createAttributes: boolean; // This might be the `attributes` field you're missing.
//   orgId: string;
//   attributes?: ItemAttribute[]; // Add this line
//   quantity: number | string;
//   uom: string;
//   //stockQuantity: number;
//   expiryDate: { _seconds: number; _nanoseconds: number };
//   batchNumber: number;
//   lotNumber: number;
//   discountRate: number;
//   warehouseId: number;
//   warehouse: string;
// }

// const ViewInventory: React.FC = () => {
//   const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
//     page: 0,
//     pageSize: 10,
//   });
//   const orgId = localStorage.getItem("orgId") || "GOO@PANACCO101";
//   const [searchText, setSearchText] = useState("");
//   const [filteredRows, setFilteredRows] = useState<Item[]>([]);
//   const [rows, setRows] = useState<Item[]>([]);
//   const { enqueueSnackbar } = useSnackbar();

//   const handleDelete = async (itemId: string) => {
//     const requestData: IUpdateItemRequest = {
//       itemId,
//       orgId,
//     };
  
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You will not be able to recover this item!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await deleteItem(requestData);
//           // Update rows after deletion
//           const updatedRows = rows.filter((row) => row.itemId !== itemId);
//           setRows(updatedRows);
//           setFilteredRows(updatedRows);
//           enqueueSnackbar("Item deleted successfully!", {
//             variant: "success",
//           });
//         } catch (error: any) {
//           console.error("Failed to delete item:", error);
//           enqueueSnackbar(`Failed to delete item: ${error.message}`, {
//             variant: "error",
//           });
//         }
//       }
//     }); // This parenthesis was missing
//   };
//   //Handle edit
//   const handleEditClick = (itemRowData: any) => {
//     // Redirect to the edit page with the rowId (e.g., passing the item ID as a URL parameter)
//     navigate("/dashboard/inventory/edit-inventory", { state: { itemRowData } });
//   };
//   //view item by item id in details

//   const handleView = async (item: any) => {
//     //console.log("Item view :", item.itemId);
//     navigate("/dashboard/inventory/view-item-details", { state: { item } });
//   };
//   useEffect(() => {
//     const fetchItems = async () => {
//       Swal.fire({
//         title: "<strong>Loading Inventory Items...</strong>",
//         html: "<i>Please wait while we fetch the data</i>",
//         allowOutsideClick: false,
//         width: 400,
//         padding: "1rem",
//         background: "#f2f2f2",
//         backdrop: `
//           rgba(0,0,123,0.4)
//         `,
//         didOpen: () => {
//           Swal.showLoading();
//         },
//       });
//       try {
//         const orgId = localStorage.getItem("orgId") || "GOO@PANACCO101";
//         const items = await getItems(orgId);
//           // Fetch categories
//       const categories = await fetchCategories(orgId);
//       const categoryMap = categories.reduce((acc: { [x: string]: any; }, category: { categoryId: string | number;categoryName: any; }) => {
//         acc[category.categoryId] = category.categoryName;
//         return acc;
//       }, {} as Record<string, string>);
// // Fetch brands for each category
// let brandMap: Record<string, string> = {};
// let brandList: Array<{ brandId: string | number; brandName: string }> = [];

// for (const category of categories) {
//   try {
//     const brands = await getBrands(orgId, category?.categoryId);
    
//     if (brands?.length > 0) {
//       brands.forEach((brand: { brandId: any; brandName: any; }) => {
//         brandMap[brand.brandId] = brand.brandName;
//         brandList.push(brand);
//       });
//     }
//   } catch (error) {
//     console.error(`Error fetching brands for category ${category?.categoryId}:`, error);
//   }
// }

// // Fetch manufacturers for each brand
// let manuMap: Record<string, string> = {};

// for (const brand of brandList) {
//   try {
//     const manufacturers = await getManufacturer(orgId, brand.brandId);

//     if (manufacturers?.length > 0) {
//       manufacturers.forEach((manu: { manufacturerId: string | number; manufacturerName: string; }) => {
//         manuMap[manu.manufacturerId] = manu.manufacturerName;
//       });
//     }
//   } catch (error) {
//     console.error(`Error fetching manufacturers for brand ${brand.brandId}:`, error);
//   }
// }
//       // // Fetch brands for each category
//       // let brands;
//       // let brandMap: Record<string, string> = {};
//       // for (const category of categories) {
//       //  brands = await getBrands(orgId, category?.categoryId);
//       //   brands.forEach((brand: { id: string | number; name: string; }) => {
//       //     brandMap[brand.id] = brand.name;
//       //   });
//       // }
//       //         // Fetch manufacturers
//       //         let manuMap: Record<string, string> = {};
//       //         for (const brand of brands) {
//       //           const manufacturer = await getManufacturer(orgId, brand.id);
//       //           brand.forEach((manu: { id: string | number; name: string; }) => {
//       //             manuMap[manu.id] = manu.name;
//       //           });
//       //         }
//       // const manufacturers = await getManufacturer(orgId,"");
//       // const manufacturerMap = manufacturers.reduce((acc, manufacturer) => {
//       //   acc[manufacturer.id] = manufacturer.name;
//       //   return acc;
//       // }, {} as Record<string, string>);



//         // Map API response to your local data structure
//         const formattedItems = items.map((item) => ({
//           id: item.id,
//           itemId: item.itemId,
//           type: item.type,
//           name: item.name || "N/A",
//           sku: item.sku,
//           costPrice: item.costPrice,
//           sellingPrice: item.sellingPrice,
//           upc: item.upc,
//           ian: item.ian,
//           hsn: item.hsn,
//           reorderPoint: item.reorderPoint,
//           desc: item.desc || "No Description",
//           brandId: item.brandId ? brandMap[String(item.brandId)] || "Unbranded" : "No Brand", 
//           categoryId: item.categoryId ? categoryMap[String(item.categoryId)] || "Uncategorized" : "No Category", // ,//`${item.categoryId}`,
//           manufacturerId: item.manufacturerId ? manuMap[String(item.manufacturerId)] || "Unmanufacturere" : "No Manufacturer",
//           itemType: item.itemType,
//           taxable: item.taxable,
//           createAttributes: item.createAttributes,
//           orgId: orgId,
//           itemAttributes: item.itemAttribute,
//           quantity: item.quantity,
//           uom: "", // Add default value for uom
//           expiryDate: { _seconds: 0, _nanoseconds: 0 }, // Add default value for expiryDate
//           batchNumber: 0, // Add default value for batchNumber
//           lotNumber: 0, // Add default value for lotNumber
//           discountRate: 0, // Add default value for discountRate
//           warehouseId: 1, // Add default value for warehouseId
//           warehouse: item.warehouseName, // Add default value for warehouseName
//         }));
//         setRows(formattedItems); // Assuming setRows expects an array of your local data structure
//         // Set initial rows
//         setFilteredRows(formattedItems);
//         Swal.close();
//       } catch (error : any) {
//         console.error("Failed to load inventory items:", error);
//         Swal.close();
//         enqueueSnackbar(error.message || "An error occurred", {
//           variant: "error",
//         });
//       }
//     };
//     fetchItems();
//   }, []);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       const lowercasedSearchText = searchText.toLowerCase();
//       const filtered = rows.filter(
//         (item) =>
//           item.name.toLowerCase().includes(lowercasedSearchText) ||
//           item.categoryId.toLowerCase().includes(lowercasedSearchText) ||
//           item.brandId.toLowerCase().includes(lowercasedSearchText) ||
//           item.manufacturerId.toLowerCase().includes(lowercasedSearchText)
//       );
//       setFilteredRows(filtered);
//     }, 300); // 300ms debounce
//     return () => clearTimeout(timer);
//   }, [searchText, rows]);
//   const navigate = useNavigate(); // Initialize the useNavigate hook
//   const columns: GridColDef[] = [
//     //{ field: "itemId", headerName: "Item Id", width: 80 },
//     { field: "name", headerName: HEADER_NAMES.ITEM_NAME, width: 150},
//     { field: "desc", headerName: HEADER_NAMES.DESCRIPTION, width: 150 },
//     { field: "hsn", headerName: HEADER_NAMES.HSN, width: 90 },
//     // { field: "type", headerName: "Type", width: 100 },
//     { field: "quantity", headerName:  HEADER_NAMES.QUANTITY, width: 80 },
//     { field: "costPrice", headerName: HEADER_NAMES.COST_PRICE, width: 110 },
//     { field: "sellingPrice", headerName: HEADER_NAMES.SELLING_PRICE, width: 120},
//     // { field: "upc", headerName: "UPC", width: 150 },
//     { field: "categoryId", headerName:  HEADER_NAMES.CATEGORY, width: 120 },
//     { field: "brandId", headerName: HEADER_NAMES.BRAND, width: 120 },
//     { field: "manufacturerId", headerName: HEADER_NAMES.MANUFACTURER, width: 120},
//     {
//       field: "actions",
//       headerName: HEADER_NAMES.ACTIONS,
//       width: 150,
//       renderCell: (params) => (
//         <>
//           {/* <div
//             className="action-buttons"
//             style={{ display: "flex", gap: "0.1px" }}
//           >
//             <button
//               className="delete-button"
//               onClick={() => handleDelete(params.row.itemId)}
//             >
//               🗑️
//             </button>
//             <button
//               className="edit-button"
//               onClick={() => handleEditClick(params.row)}
//             >
//               ✏️
//             </button>
//             <button
//               className="view-button"
//               onClick={() => handleView(params.row)}
//             >
//               👁️
//             </button>
//           </div> */}
//           <Tooltip title="Edit Inventry">
//          <IconButton size="small" sx={{ padding: 0.5 }}
//            onClick={() => handleEditClick(params.row)}       
//           ><EditIcon fontSize="small"  />
//           </IconButton>
//           </Tooltip>          
//            <Tooltip title="Delete Inventry" arrow>
//           <IconButton
//            onClick={() => handleDelete(params.row.itemId)}
//             size="small"
//             color="error"
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//            <Tooltip title="View Inventry" arrow>
//           <IconButton
//             onClick={() => handleView(params.row)}
//             size="small"
//             color="primary"
//           >
//             <VisibilityIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//         </>
//       ),
//     },
//   ];
//   return (
//     <>
      
//         <div className="page-location">
//           <span>Inventory &gt; View Inventory</span>
//         </div>
//       <Container maxWidth="lg" sx={{ padding: 1 }}>
//         <div
//           className="view-inventory-container"
//           style={{ height: 600, width: "100%" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               marginBottom: "1rem",
//             }}
//           >
//             {/* Stylish Search Bar */}
//             <div style={{ position: "relative", width: "50%" }}>
//               <input
//                 type="text"
//                 placeholder={LBL_Search}
//                 value={searchText}
//                 onChange={(e) => setSearchText(e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "0.75rem 2.5rem 0.75rem 1rem",
//                   borderRadius: "25px",
//                   border: "1px solid #ccc",
//                   fontSize: "1rem",
//                   outline: "none",
//                   boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
//                 }}
//               />
//               <span
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   right: "1rem",
//                   transform: "translateY(-50%)",
//                   color: "#999",
//                   pointerEvents: "none",
//                 }}
//               >
//                 🔍
//               </span>
//             </div>
//             {/* <select
//                         value={paginationModel.pageSize}
//                         onChange={(e) => setPaginationModel({ page: 0, pageSize: +e.target.value })}
//                         style={{
//                             width: "100px",
//                             padding: "0.5rem",
//                             fontSize: "1rem",
//                             border: "1px solid #ccc",
//                             borderRadius: "5px",
//                             display: "flex",
//                             alignItems: "center",
//                         }}
//                     >
//                         <option value={10}>10</option>
//                         <option value={20}>20</option>
//                         <option value={50}>50</option>
//                     </select> */}
//           </div>
//           <DataGrid
//             rows={filteredRows}
//             columns={columns}
//             pagination
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={[10, 20, 50]}
//             rowCount={rows.length}
//             sx={{
//               "& .MuiDataGrid-main": {
//                 overflowX: "hidden", // Remove the horizontal scrollbar
//               },
//               "& .MuiTablePagination-select": {
//                 minWidth: "60px", // Set the dropdown width
//                 fontSize: "0.875rem", // Smaller font size
//                 padding: "0.25rem", // Smaller padding
//               },
//               "& .MuiTablePagination-selectLabel": {
//                 fontSize: "0.875rem", // Smaller font size for label
//               },
//               "& .MuiTablePagination-actions": {
//                 display: "flex",
//                 justifyContent: "space-between",
//                 width: "100px",
//                 gap: "5px",
//                 alignItems: "center",
//                 "& button": {
//                   padding: "0.2rem",
//                   border: "1px solid #ccc",
//                   borderRadius: "3px",
//                   backgroundColor: "#fff",
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                   },
//                 },
//               },
//               "& .MuiTablePagination-toolbar": {
//                 justifyContent: "flex-start",
//                 "& p": {
//                   fontSize: "1rem",
//                   marginRight: "1rem",
//                 },
//               },
//               "& .MuiDataGrid-cell": {
//                   fontSize: "11px", // Adjust font size
//                 },
//             }}
//           />

//           {/* <DataGrid
//                     rows={filteredRows}
//                     columns={columns}
//                     pagination
//                     paginationModel={paginationModel}
//                     onPaginationModelChange={setPaginationModel}
//                     pageSizeOptions={[10, 20, 50]}
//                     rowCount={rows.length}
//                     sx={{
//                         "& .MuiDataGrid-main": {
//                             overflowX: "hidden", // Remove the horizontal scrollbar
//                         },
//                         "& .MuiTablePagination-select": {
//                             display: "none", // Hide the page size selector
//                         },
//                         "& .MuiTablePagination-actions": {
//                             display: "flex",
//                             justifyContent: "space-between", // Align pagination buttons to the edges of the screen
//                             width: "100px",
//                             gap: "10px", // Add gap between the buttons
//                             alignItems: "center",
//                             "& button": {
//                                 padding: "0.5rem",
//                                 overflowX: "hidden",
//                                 border: "1px solid #ccc",
//                                 borderRadius: "5px",
//                                 backgroundColor: "#fff",
//                                 "&:hover": {
//                                     backgroundColor: "#f5f5f5",
//                                 },
//                             },
//                         },
//                         "& .MuiTablePagination-toolbar": {
//                             justifyContent: "flex-start", // Align info on the left
//                             "& p": {
//                                 fontSize: "1rem",
//                                 marginRight: "1rem",
//                             },
//                         },
//                     }} /> */}
//         </div>
//       </Container>
//       <Box
//         sx={{
//           position: "relative",
//           left: 0,
//           bottom: 0,
//           width: "100%",
//           mt: 10,
//         }}
//       >
//         <Footer />
//       </Box>
//     </>
//   );
// };

// export default ViewInventory;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import "../Style/AddItemModal.css";
import "../Style/Common.css";
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
import {
  deleteItem,
  fetchCategories,
  getBrands,
  getItemsList,
  getManufacturer,
} from "../Services/inventoryService";
import { DataGrid, GridColDef, GridPaginationModel } from "@mui/x-data-grid";
import { IUpdateItemRequest } from "../Interfaces/IInventory";
import Swal from "sweetalert2";
import {
  Box,
  Container,
  Card,
  CardContent,
  Stack,
  Typography,
  TextField,
  InputAdornment,
  Pagination,
  Chip,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import { useSnackbar } from "notistack";
import { HEADER_NAMES, LBL_Search } from "../Constants/LabelConstants";
 
interface ItemAttribute {
  attribute: string | number;
  option: string | number;
  orgId: string;
  availableOptions: { id: number; name: string }[];
}
 
export interface Item {
  id: string;
  itemId: string;
  type: string;
  name: string;
  sku: string;
  costPrice: number;
  sellingPrice: number;
  upc?: string;
  ian?: string;
  hsn: string;
  reorderPoint: number;
  desc: string;
  brandId: string;
  categoryId: string;
  manufacturerId: string;
  itemType: string;
  taxable: boolean;
  createAttributes: boolean;
  orgId: string;
  attributes?: ItemAttribute[];
  quantity: number | string;
  uom: string;
  expiryDate: { _seconds: number; _nanoseconds: number };
  batchNumber: number;
  lotNumber: number;
  discountRate: number;
  warehouseId: number;
  warehouse: string;
}
 
const DEBOUNCE_MS = 400;
 
const ViewInventory: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
 
  const orgId = localStorage.getItem("orgId") || "GOO@PANACCO101";
 
  // Grid data + server pagination state
  const [rows, setRows] = useState<Item[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0, // MUI DataGrid is 0-based
    pageSize: 10,
  });
  // Start as true: rows are empty on mount and the first fetch (maps + items)
  // hasn't run yet. If this defaults to false, DataGrid renders its "No rows"
  // overlay for that brief window instead of the loading spinner.
  const [loading, setLoading] = useState(true);
 
  // Search
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
 
  // Lookup maps (fetched once, not per page)
  const [categoryMap, setCategoryMap] = useState<Record<string, string>>({});
  const [brandMap, setBrandMap] = useState<Record<string, string>>({});
  const [manuMap, setManuMap] = useState<Record<string, string>>({});
  const [mapsLoaded, setMapsLoaded] = useState(false);
 
  // ---- Debounce search input ----
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText.trim());
      setPaginationModel((prev) => ({ ...prev, page: 0 })); // reset to first page on new search
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [searchText]);
 
  // ---- Fetch category/brand/manufacturer maps once ----
  useEffect(() => {
    const buildMaps = async () => {
      try {
        const categories = await fetchCategories(orgId);
        const catMap = categories.reduce(
          (acc: Record<string, string>, category: any) => {
            acc[category.categoryId] = category.categoryName;
            return acc;
          },
          {} as Record<string, string>
        );
 
        let brMap: Record<string, string> = {};
        let brandList: Array<{ brandId: string | number; brandName: string }> = [];
        for (const category of categories) {
          try {
            const brands = await getBrands(orgId, category?.categoryId);
            if (brands?.length > 0) {
              brands.forEach((brand: { brandId: any; brandName: any }) => {
                brMap[brand.brandId] = brand.brandName;
                brandList.push(brand);
              });
            }
          } catch (error) {
            console.error(`Error fetching brands for category ${category?.categoryId}:`, error);
          }
        }
 
        let mMap: Record<string, string> = {};
        for (const brand of brandList) {
          try {
            const manufacturers = await getManufacturer(orgId, brand.brandId);
            if (manufacturers?.length > 0) {
              manufacturers.forEach((manu: { manufacturerId: string | number; manufacturerName: string }) => {
                mMap[manu.manufacturerId] = manu.manufacturerName;
              });
            }
          } catch (error) {
            console.error(`Error fetching manufacturers for brand ${brand.brandId}:`, error);
          }
        }
 
        setCategoryMap(catMap);
        setBrandMap(brMap);
        setManuMap(mMap);
      } catch (error: any) {
        console.error("Failed to load lookup maps:", error);
        enqueueSnackbar(error.message || "Failed to load category/brand/manufacturer data", {
          variant: "error",
        });
      } finally {
        setMapsLoaded(true);
      }
    };
    buildMaps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 
  // ---- Fetch a page of items (runs on mount, page change, pageSize change, search change) ----
  const fetchPage = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getItemsList({
        orgId,
        page: paginationModel.page + 1, // convert to 1-based for API
        pageSize: paginationModel.pageSize,
        search: debouncedSearch,
        sortBy: "createdDate",
        sortOrder: "desc",
      });
       if(response.success) {
      const formattedItems = response.items.map((item: any) => ({
        id: item.id,
        itemId: item.itemId,
        type: item.type,
        name: item.name || "N/A",
        sku: item.sku,
        costPrice: item.costPrice,
        sellingPrice: item.sellingPrice,
        upc: item.upc,
        ian: item.ian,
        hsn: item.hsn,
        reorderPoint: item.reorderPoint,
        desc: item.desc || "No Description",
        brandId: item.brandId ? brandMap[String(item.brandId)] || "Unbranded" : "No Brand",
        categoryId: item.categoryId
          ? categoryMap[String(item.categoryId)] || "Uncategorized"
          : "No Category",
        manufacturerId: item.manufacturerId
          ? manuMap[String(item.manufacturerId)] || "Unmanufacturere"
          : "No Manufacturer",
        itemType: item.itemType,
        taxable: item.taxable,
        createAttributes: item.createAttributes,
        orgId,
        itemAttributes: item.itemAttribute,
        quantity: item.quantity,
        uom: item.uom || "",
        expiryDate: item.expiryDate || { _seconds: 0, _nanoseconds: 0 },
        batchNumber: item.batchNumber || 0,
        lotNumber: item.lotNumber || 0,
        discountRate: item.discountRate || 0,
        warehouseId: item.warehouseId || 1,
        warehouse: item.warehouse || item.warehouseName || "",
      }));
 
      setRows(formattedItems);
      setTotalCount(response.totalCount || 0);
    }else
    {
      enqueueSnackbar(response.message || "An error occurred", { variant: "error" });
    }
    } catch (error: any) {
      console.error("Failed to load inventory items:", error);
      enqueueSnackbar(error.message || "An error occurred", { variant: "error" });
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, paginationModel.page, paginationModel.pageSize, debouncedSearch, brandMap, categoryMap, manuMap]);
 
  useEffect(() => {
    // Wait for lookup maps before the first fetch so names render correctly right away.
    if (mapsLoaded) {
      fetchPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapsLoaded, paginationModel.page, paginationModel.pageSize, debouncedSearch]);
 
  // ---- Shared handlers (unchanged behavior) ----
  const handleDelete = async (itemId: string) => {
    const requestData: IUpdateItemRequest = { itemId, orgId };
 
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteItem(requestData);
          enqueueSnackbar("Item deleted successfully!", { variant: "success" });
          // Re-fetch current page from server so pagination/count stay correct
          fetchPage();
        } catch (error: any) {
          console.error("Failed to delete item:", error);
          enqueueSnackbar(`Failed to delete item: ${error.message}`, { variant: "error" });
        }
      }
    });
  };
 
  const handleEditClick = (itemRowData: any) => {
    navigate("/dashboard/inventory/edit-inventory", { state: { itemRowData } });
  };
 
  const handleView = async (item: any) => {
    navigate("/dashboard/inventory/view-item-details", { state: { item } });
  };
 
  // ---- Serial number: page offset + row index within current page ----
  const rowIndexMap = useMemo(() => {
    const map = new Map<string, number>();
    rows.forEach((row, idx) => {
      map.set(row.id, paginationModel.page * paginationModel.pageSize + idx + 1);
    });
    return map;
  }, [rows, paginationModel]);
 
  // ---- Columns: Actions FIRST, then S.No, then original field order ----
  const columns: GridColDef[] = [
    {
      field: "actions",
      headerName: HEADER_NAMES.ACTIONS,
      width: 130,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit Inventry">
            <IconButton size="small" sx={{ padding: 0.5 }} onClick={() => handleEditClick(params.row)}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Inventry" arrow>
            <IconButton onClick={() => handleDelete(params.row.itemId)} size="small" color="error">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Inventry" arrow>
            <IconButton onClick={() => handleView(params.row)} size="small" color="primary">
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
    {
      field: "sNo",
      headerName: "S.No",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) => rowIndexMap.get(params.row.id) ?? "",
    },
    { field: "name", headerName: HEADER_NAMES.ITEM_NAME, width: 150 },
    { field: "desc", headerName: HEADER_NAMES.DESCRIPTION, width: 150 },
    { field: "hsn", headerName: HEADER_NAMES.HSN, width: 90 },
    { field: "quantity", headerName: HEADER_NAMES.QUANTITY, width: 80 },
    { field: "costPrice", headerName: HEADER_NAMES.COST_PRICE, width: 110 },
    { field: "sellingPrice", headerName: HEADER_NAMES.SELLING_PRICE, width: 120 },
    { field: "categoryId", headerName: HEADER_NAMES.CATEGORY, width: 120 },
    { field: "brandId", headerName: HEADER_NAMES.BRAND, width: 120 },
    { field: "manufacturerId", headerName: HEADER_NAMES.MANUFACTURER, width: 120 },
  ];
 
  // ---- Search bar (shared by desktop + mobile) ----
  const searchBar = (
    <TextField
      fullWidth
      size="small"
      placeholder={LBL_Search}
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-root": { borderRadius: "25px", backgroundColor: "#fff" },
      }}
    />
  );
 
  // ---- Mobile: card list instead of DataGrid ----
  const mobileList = (
    <Stack spacing={1.5}>
      {loading && (
        <Stack alignItems="center" py={4}>
          <CircularProgress size={28} />
        </Stack>
      )}
      {!loading && rows.length === 0 && (
        <Typography align="center" color="text.secondary" py={4}>
          No items found
        </Typography>
      )}
      {!loading &&
        rows.map((row) => (
          <Card key={row.id} variant="outlined">
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Stack spacing={0.5} sx={{ minWidth: 0 }}>
                  <Typography variant="caption" color="text.secondary">
                    #{rowIndexMap.get(row.id)}
                  </Typography>
                  <Typography variant="subtitle1" fontWeight={600} noWrap>
                    {row.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {row.desc}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={0}>
                  <Tooltip title="Edit Inventry">
                    <IconButton size="small" onClick={() => handleEditClick(row)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Inventry" arrow>
                    <IconButton size="small" color="error" onClick={() => handleDelete(row.itemId)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="View Inventry" arrow>
                    <IconButton size="small" color="primary" onClick={() => handleView(row)}>
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Stack>
 
              <Stack direction="row" spacing={1} flexWrap="wrap" mt={1.5} rowGap={1}>
                <Chip size="small" label={`Qty: ${row.quantity}`} />
                <Chip size="small" label={`Cost: ${row.costPrice}`} />
                <Chip size="small" label={`Price: ${row.sellingPrice}`} />
                <Chip size="small" label={row.categoryId} variant="outlined" />
                <Chip size="small" label={row.brandId} variant="outlined" />
              </Stack>
            </CardContent>
          </Card>
        ))}
 
      {totalCount > paginationModel.pageSize && (
        <Stack alignItems="center" py={2}>
          <Pagination
            count={Math.ceil(totalCount / paginationModel.pageSize)}
            page={paginationModel.page + 1}
            onChange={(_, newPage) =>
              setPaginationModel((prev) => ({ ...prev, page: newPage - 1 }))
            }
            color="primary"
            size="small"
          />
        </Stack>
      )}
    </Stack>
  );
 
  return (
    <>
      <div className="page-location">
        <span>Inventory &gt; View Inventory</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        <Box sx={{ mb: 2, maxWidth: isMobile ? "100%" : "50%" }}>{searchBar}</Box>
 
        {isMobile ? (
          <Box sx={{ cursor: loading ? "wait" : "default" }}>{mobileList}</Box>
        ) : (
          <div style={{ height: 600, width: "100%", cursor: loading ? "wait" : "default" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              paginationMode="server"
              rowCount={totalCount}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 20, 50]}
              disableColumnMenu
              slotProps={{
                loadingOverlay: {
                  variant: "linear-progress",
                  noRowsVariant: "linear-progress",
                },
              }}
              sx={{
                "& .MuiDataGrid-main": { overflowX: "hidden" },
                "& .MuiTablePagination-select": { minWidth: "60px", fontSize: "0.875rem", padding: "0.25rem" },
                "& .MuiTablePagination-selectLabel": { fontSize: "0.875rem" },
                "& .MuiTablePagination-actions": {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100px",
                  gap: "5px",
                  alignItems: "center",
                  "& button": {
                    padding: "0.2rem",
                    border: "1px solid #ccc",
                    borderRadius: "3px",
                    backgroundColor: "#fff",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                  },
                },
                "& .MuiTablePagination-toolbar": {
                  justifyContent: "flex-start",
                  "& p": { fontSize: "1rem", marginRight: "1rem" },
                },
                "& .MuiDataGrid-cell": { fontSize: "11px" },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f5f5f5",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                   fontWeight: 500,    
                    color: "#141111",    
                  },
              }}
            />
          </div>
        )}
      </Container>
      <Box sx={{ position: "relative", left: 0, bottom: 0, width: "100%", mt: 10 }}>
        <Footer />
      </Box>
    </>
  );
};
 
export default ViewInventory;